import { useState, useEffect } from "react";
import MUIDataTableCustomStyle from "../MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { ETableEditAction } from "../../Utils/Enums";
import { endpoints } from "../../Utils/UrlEnum";
import genericStyles from "../../Styles/genericStyles.module.css";
import ExamSetForm from "./ExamSetForm";
import GenericModal from "../GenericModal";
import { Button, Chip } from "@mui/material";
import { FormsIds } from "../../Utils/Constants";
import { ExamSetModel } from "../../Utils/Models";
import useCustomMemo from "../../Hooks/useCustomMemo";
import { getData } from "../../Services/getData";
import { isDefined } from "../../Utils/Utils";

export default function ExamSetsTable(props: { name: string }) {
  const [openModal, setOpenModal] = useState(false);
  const [contextValue, setContextValue] = useState<ExamSetModel | undefined>();
  const [triggerReload, setTriggerReload] = useState(false);
  const [products, setProducts] = useState<any[]>([]);
  const memo = useCustomMemo();
  const examCategories = memo.storage.examCategories;

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await getData(endpoints.product.main);
      if (response?.data) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const columns = [
    {
      name: "name",
      label: Vocabulary.name,
      options: { filter: true, sort: true },
    },
    {
      name: "examCategory",
      label: Vocabulary.examCategory,
      options: {
        customBodyRender: (value: any) => {
          return isDefined(value) ? value : "-";
        },
      },
    },
    {
      name: "productsIds",
      label: Vocabulary.products,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          const productsList = value || [];

          if (productsList.length === 0) {
            return <span>-</span>;
          }

          return (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
              {productsList.map((product: any, index: number) => (
                <Chip
                  key={`${product._id || product.name}-${index}`}
                  label={product.name}
                  size="small"
                />
              ))}
            </div>
          );
        },
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <MUIDataTableCustomStyle
        title={Vocabulary.examSet}
        columns={columns}
        CRUDEndPoint={endpoints.examSets}
        onEditAction={ETableEditAction.MODAL}
        setTriggerReload={() => setTriggerReload(!triggerReload)}
        triggerReload={triggerReload}
        handleModalForm={setOpenModal}
        setContextValue={setContextValue}
        addOrEditForm={
          <GenericModal
            title={Vocabulary.addExamSet}
            open={openModal}
            onClose={() => {
              setOpenModal(false);
              setContextValue(undefined);
            }}
            actions={
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setOpenModal(false);
                    setContextValue(undefined);
                  }}
                >
                  {Vocabulary.cancel}
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  color="primary"
                  form={FormsIds.examSetForm}
                >
                  {Vocabulary.save}
                </Button>
              </div>
            }
          >
            <ExamSetForm
              selectedRow={contextValue}
              onClose={() => {
                setTriggerReload(!triggerReload);
                setOpenModal(false);
                setContextValue(undefined);
              }}
              examCategories={examCategories}
              products={products}
            />
          </GenericModal>
        }
        // addOrEditForm={<ExamSetForm ... />} // Uncomment and implement when you have a form
        // hideDeleteButton={false}
        // hideEditButton={false}
        // hideAddButton={false}
      />
    </div>
  );
}
